import { render, staticRenderFns } from "./Receipt-payment-methods.vue?vue&type=template&id=c65ae8f2&scoped=true"
import script from "./Receipt-payment-methods.vue?vue&type=script&lang=js"
export * from "./Receipt-payment-methods.vue?vue&type=script&lang=js"
import style0 from "./Receipt-payment-methods.vue?vue&type=style&index=0&id=c65ae8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65ae8f2",
  null
  
)

export default component.exports